import { enqueueSnackbar } from "notistack";
import { AFSClassification, PPTClassification, PPTRamsesDescription, Reconciliation, ServerAPIResponse } from "../helpers/interfaces";
import { callServerAPI, showBackDrop } from "../helpers/utils";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal);

//AFS
export const getAllAFSClassifications = async () => {
    return await new Promise<AFSClassification[]>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Loading AFS Classification"));
        callServerAPI<ServerAPIResponse<AFSClassification[]>>('GET',  `/api/v1/AFSClassification?PageSize=100&OrderBy=ASCENDING&api-version=1`, null, true)
            .then(response => {
                MySwal.close()
                resolve(response.data.data)
            })
    })
}
export async function createAFSClassification(name: string) {
    const afsData ={name:name}
    return await new Promise<AFSClassification>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Creating new AFS Classification"));
        callServerAPI<ServerAPIResponse<AFSClassification>>('POST', `/api/v1/AFSClassification?api-version=1`, afsData, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("AFS Classification Created", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}

export async function updateAFSClassification(id: string , name: string) {
    const afsData ={name:name}
    return await new Promise<AFSClassification>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Updating AFS Classification"));
        callServerAPI<ServerAPIResponse<AFSClassification>>('PUT', `/api/v1/AFSClassification?id=${id}&api-version=1`, afsData, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("AFS Classification Updated", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}

export async function deleteAFSClassification(id: string) {
    return await new Promise<void>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Deleting AFS Classification"));
        await callServerAPI<any>('DELETE', `/api/v1/AFSClassification?id=${id}&api-version=1`, null, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("AFS Classification Deleted", { variant: 'success' });
                resolve()
            })
    })
}

//PPT
export const getAllPPTClassifications = async () => {
    return await new Promise<PPTClassification[]>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Loading PPT Classification"));
        callServerAPI<ServerAPIResponse<PPTClassification[]>>('GET',  `/api/v1/PPTClassification?PageSize=100&OrderBy=ASCENDING&api-version=1`, null, true)
            .then(response => {
                MySwal.close()
                resolve(response.data.data)
            })
    })
}
export async function createPPTClassification(name: string) {
    const pptData ={name:name}
    return await new Promise<PPTClassification>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Creating new PPT Classification"));
        callServerAPI<ServerAPIResponse<PPTClassification>>('POST', `/api/v1/PPTClassification?api-version=1`, pptData, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("PPT Classification Created", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}

export async function updatePPTClassification(id: string , name: string) {
    const pptData ={name:name}
    return await new Promise<PPTClassification>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Updating PPT Classification"));
        callServerAPI<ServerAPIResponse<PPTClassification>>('PUT', `/api/v1/PPTClassification?id=${id}&api-version=1`, pptData, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("PPT Classification Updated", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}

export async function deletePPTClassification(id: string) {
    return await new Promise<void>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Deleting PPT Classification"));
        await callServerAPI<any>('DELETE', `/api/v1/PPTClassification?id=${id}&api-version=1`, null, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("PPT Classification Deleted", { variant: 'success' });
                resolve()
            })
    })
}

//Reconciliation
export const getAllReconciliation = async () => {
    return await new Promise<Reconciliation[]>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Loading Reconciliation Mapping Key "));
        callServerAPI<ServerAPIResponse<Reconciliation[]>>('GET',  `/api/v1/Reconciliation?PageSize=100&OrderBy=ASCENDING&api-version=1`, null, true)
            .then(response => {
                MySwal.close()
                resolve(response.data.data)
            })
    })
}
export async function createReconciliation(name: string) {
    const recData ={name:name}
    return await new Promise<Reconciliation>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Creating new Reconciliation Mapping Key"));
        callServerAPI<ServerAPIResponse<Reconciliation>>('POST', `/api/v1/Reconciliation?api-version=1`, recData, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("Reconciliation Mapping Key Created", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}

export async function updateReconciliation(id: string , name: string) {
    const recData ={name:name}
    return await new Promise<Reconciliation>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Updating Reconciliation Mapping Key"));
        callServerAPI<ServerAPIResponse<Reconciliation>>('PUT', `/api/v1/Reconciliation?id=${id}&api-version=1`, recData, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("Reconciliation Mapping Key Updated", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}

export async function deleteReconciliation(id: string) {
    return await new Promise<void>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Deleting Reconciliation Mapping Key"));
        await callServerAPI<any>('DELETE', `/api/v1/Reconciliation?id=${id}&api-version=1`, null, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("Reconciliation Mapping Key Deleted", { variant: 'success' });
                resolve()
            })
    })
}

//PPTRameses
export const getAllPPTRameses= async () => {
    return await new Promise<PPTRamsesDescription[]>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Loading PPT Ramses Description Mapping Key "));
        callServerAPI<ServerAPIResponse<PPTRamsesDescription[]>>('GET',  `/api/v1/PPTRamsesDescription?PageSize=100&OrderBy=ASCENDING&api-version=1`, null, true)
            .then(response => {
                MySwal.close()
                resolve(response.data.data)
            })
    })
}
export async function createPPTRameses(name: string) {
    const recData ={name:name}
    return await new Promise<PPTRamsesDescription>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Creating new PPT Ramses Description Mapping Key"));
        callServerAPI<ServerAPIResponse<PPTRamsesDescription>>('POST', `/api/v1/PPTRamsesDescription?api-version=1`, recData, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("PPT Ramses Description Mapping Key Created", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}

export async function updatePPTRameses(id: string , name: string) {
    const recData ={name:name}
    return await new Promise<PPTRamsesDescription>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Updating PPT Ramses Description Mapping Key"));
        callServerAPI<ServerAPIResponse<PPTRamsesDescription>>('PUT', `/api/v1/PPTRamsesDescription?id=${id}&api-version=1`, recData, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("PPT Ramses Description Mapping Key Updated", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}

export async function deletePPTRameses(id: string) {
    return await new Promise<void>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Deleting PPT Ramses Description Mapping Key"));
        await callServerAPI<any>('DELETE', `/api/v1/PPTRamsesDescription?id=${id}&api-version=1`, null, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("PPT Ramses Description Mapping Key Deleted", { variant: 'success' });
                resolve()
            })
    })
}
//TaxTerm
export const getAllTaxTerm= async () => {
    return await new Promise<PPTRamsesDescription[]>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Loading Tax Term Mapping Key "));
        callServerAPI<ServerAPIResponse<PPTRamsesDescription[]>>('GET',  `/api/v1/TaxTerm?PageSize=100&OrderBy=ASCENDING&api-version=1`, null, true)
            .then(response => {
                MySwal.close()
                resolve(response.data.data)
            })
    })
}
export async function createTaxTerm(name: string) {
    const recData ={name:name}
    return await new Promise<PPTRamsesDescription>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Creating new Tax Term Mapping Key"));
        callServerAPI<ServerAPIResponse<PPTRamsesDescription>>('POST', `/api/v1/TaxTerm?api-version=1`, recData, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar(" Tax Term Mapping Key Created", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}

export async function updateTaxTerm(id: string , name: string) {
    const recData ={name:name}
    return await new Promise<PPTRamsesDescription>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Updating Tax Term Mapping Key"));
        callServerAPI<ServerAPIResponse<PPTRamsesDescription>>('PUT', `/api/v1/TaxTerm?id=${id}&api-version=1`, recData, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar(" Tax Term Mapping Key Updated", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}

export async function deleteTaxTerm(id: string) {
    return await new Promise<void>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Deleting  Tax Term Mapping Key"));
        await callServerAPI<any>('DELETE', `/api/v1/TaxTerm?id=${id}&api-version=1`, null, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar(" Tax Term Mapping Key Deleted", { variant: 'success' });
                resolve()
            })
    })
}